<template>
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-11 col-sm-8">
            <h1>{{ result.title }}</h1>
            <p> {{ result.intro }} </p>
            <div class="text-left">
                <h3>Sabiduría</h3>
                <ul>
                    <li v-for="sabiduria in result.sabidurias" :key="sabiduria">
                        {{ sabiduria }}
                    </li>
                </ul>
                <h3>Sombra</h3>
                <ul>
                    <li v-for="sombra in result.sombras" :key="sombra">
                        {{ sombra }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            results: [{
                title: 'Inteligencia Intuitiva',
                intro: 'Las personas cuyo estilo predominante es la inteligencia intuitiva se sienten cómodos con el pensamiento creativo, las sesiones de intercambio de ideas y preguntando “qué pasaría si...”. Son intuitivos al tomar decisiones y prefieren basar los planes de acción en personas, ideas creativas y opiniones antes que en datos y análisis. Disfrutan los ambientes acelerados, discusiones emocionales y personas energéticas. Ayudan a otros estilos a “ver el camino” con sus capacidades de visionarios.',
                sabidurias: [
                    'Creativos e innovadores',
                    'Capaces de conectar los puntos y ver el panorama general',
                    'Pensadores conceptuales y abstractos',
                    'Orientados al cambio',
                    'Capaces de ver lo que es más importante',
                    'Inspiradores y capaces de levantar el ánimo',
                    'Espontáneos',
                ],
                sombras: [
                    'Desenfocados',
                    'Excesivamente comprometidos',
                    'Impulsivos y adictivos.',
                    'Incapaces de terminar lo que empiezan.',
                    'No están atentos a los detalles.',
                    'Se aburren con facilidad.',
                    'No son prácticos.',
                ]
            }, {
                title: 'Inteligencia de Acción',
                intro: 'Las personas cuyo estilo principal es la inteligencia de acción están orientadas a resultados y se sienten más cómodas usando enfoques directos y sensatos en la toma de decisiones y relaciones interpersonales. Las personas que prefieren la inteligencia de acción para influenciar a los demás ven las situaciones como retos a resolver y quieren que las cosas se hagan lo más rápido y directamente posible. Son exigentes con ellos mismos y tienen grandes expectativas de los demás. Ellos representan y dirigen el camino.',
                sabidurias: [
                    'Orientados a tareas y resultados',
                    'Valientes y dispuestos a correr riesgos',
                    'Llenos de empuje y ambición',
                    'Disciplinados',
                    'Auténticos—predican con el ejemplo',
                    'Fuertes y perseverantes',
                ],
                sombras: [
                    'Demasiado ocupados',
                    'Competencia excesiva y agresividad',
                    'Insensibilidad',
                    'Micro gestión',
                    'Atropellan a los demás',
                    'Tendencia a “disparar primero y preguntar después”',
                    'Controladores',
                ]
            }, {
                title: 'Inteligencia Emocional',
                intro: 'Las personas cuyo estilo preferido es la inteligencia emocional valoran las relaciones, la dedicación y la lealtad. Los motiva un ambiente de trabajo de cooperación y apoyo que valore el trabajo en equipo. Las personas que prefieren usar la inteligencia emocional para influenciar a los demás se alimentan del estímulo y la ayuda; prefieren un estilo enfocado en las personas sobre un enfoque directo al grano y basado estrictamente en datos. No responden bien cuando los apresuran o amenazan. Despiertan las emociones de los demás.',
                sabidurias: [
                    'Conciencia emocional y empatía',
                    'Son buenos construyendo relaciones',
                    'Jugadoresdeequipo,cooperadores',
                    'Impulsados por los valores',
                    'Orientados al servicio',
                    'Son buenos escuchando y comunicando',
                ],
                sombras: [
                    'Demasiado sensibles',
                    'Tienden a tomarse las cosas personales',
                    'Dependientes',
                    'Evitan el conflicto',
                    'No son asertivos',
                    'Aptos para sentirse culpables por las diferencias',
                    'Excesivamente orgullosos',
                ]
            }, {
                title: 'Inteligencia Intelectual',
                intro: 'Las personas cuyo estilo preferido es la inteligencia intelectual valoran los enfoques formales y sistemáticos para resolver problemas y tomar decisiones. Se sienten más cómodos con datos y cifras que con opiniones y emociones. Las relaciones son un medio para lograr un fin. Las personas que prefieren usar la inteligencia intelectual para influenciar a los demás tienden a ser reservadas y profesionales en lugar de amables y expresivas. Se especializan en conocer el mundo.',
                sabidurias: [
                    'Curiosidad intelectual',
                    'Objetividad',
                    'Metódicos y organizados',
                    'Se concentran en la realidad, el presente, lo específico y concreto',
                    'Conocimiento comercial, técnico y perspicacia',
                ],
                sombras: [
                    'Obsesivos y duros',
                    'Rígidos e inflexibles',
                    'Les incomoda la ambigüedad',
                    'Expuestos a la parálisis del análisis',
                    'No pueden ver el panorama general',
                    'Se hunden en los detalles',
                    'Aparentan ser insensibles',
                ]
            }],
            ...mapGetters(['getAnswers'])
        }
    },
    computed: {
        result: function() {
            let answers = this.getAnswers()
            let i = answers.indexOf(Math.max(...answers));
            return this.results[i]
        }
    },

}
</script>
